module.exports = __webpack_public_path__ + "img/ilumaps.d134f6a7.jpg";